/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useMemo } from 'react';
import 'styled-components/macro';
import { AuthContext } from 'context/authContext';
import Button from 'components/atoms/Button';
import Grid from 'components/atoms/Grid';

import adminService from 'services/admin.service';

import Field from 'components/molecules/Field';
import Form, { useForm } from 'components/molecules/Form';
import Toast from 'components/molecules/Toast';
import { useContextHook } from 'use-context-hook';
import { LangConverter } from 'helpers/common';
import Select from 'components/atoms/Select';
import { useTranslation } from 'helpers/useTranslation';
import { RESELLER_TYPES } from 'helpers/constants';

function ResellerForm({ onClose = () => {}, reseller }) {
  const [form] = useForm();
  const [state, setState] = useState({});
  const [loading, setLoading] = useState(false);
  const { refetch } = useContextHook(AuthContext, ['refetch']);
  const { lang } = useContextHook(AuthContext, { lang: 1 });
  const { t } = useTranslation();
  useEffect(() => {
    if (reseller) {
      const typeOfAuthorizedCenter = RESELLER_TYPES.find(itm => itm.value === reseller?.typeOfAuthorizedCenter) ?? {
        label: 'Silver',
        value: 'silver',
      };
      const s = { ...reseller, typeOfAuthorizedCenter };
      form.setFieldsValue(s);

      setState(s);
    } else {
      form.setFieldsValue({ password: '', email: '' });
      form.setFieldsError({ password: { message: undefined }, email: { message: undefined } });
    }
  }, [reseller]);

  const onSubmit = async data => {
    const payload = { ...data, typeOfAuthorizedCenter: data?.typeOfAuthorizedCenter?.value };
    // return true;
    try {
      setLoading(true);
      const res = !reseller
        ? await adminService.createReseller(payload)
        : await adminService.updateReseller(reseller._id, payload);
      refetch();
      onClose();
      setLoading(false);
      Toast({
        type: 'success',
        message: res?.message,
      });
    } catch (ex) {
      setLoading(false);
      Toast({
        type: 'error',
        message: ex.message,
      });
    }
  };

  return (
    <Form form={form} onSubmit={onSubmit} onTouched={_ => setState(__ => ({ ...__, ..._ }))} autoComplete="off">
      <Grid
        xs={1}
        lg={2}
        colGap={20}
        css={`
          align-items: center;
        `}>
        <Form.Item
          sm
          type="text"
          label={LangConverter('First Name', lang.value)}
          name="firstName"
          placeholder={LangConverter('First Name', lang.value)}
          rules={[{ required: true, message: LangConverter('Please enter first name', lang.value) }]}>
          <Field autoComplete="given-name" />
        </Form.Item>
        <Form.Item
          sm
          type="text"
          label={LangConverter('Last Name', lang.value)}
          name="lastName"
          placeholder={LangConverter('Last Name', lang.value)}
          rules={[{ required: true, message: LangConverter('Please enter last name', lang.value) }]}>
          <Field autoComplete="family-name" />
        </Form.Item>
        {!reseller && (
          <Form.Item
            type="password"
            sm
            label={LangConverter('Password', lang.value)}
            name="password"
            placeholder={LangConverter('Password', lang.value)}
            rules={[
              {
                required: true,
              },
              { password: true },
            ]}>
            <Field autoComplete="new-password" />
          </Form.Item>
        )}
        <Form.Item
          type="email"
          sm
          label={LangConverter('email', lang.value)}
          name="email"
          placeholder={LangConverter('E-mail', lang.value)}
          rules={[
            {
              required: true,
              message: LangConverter('Email is required.', lang.value),
            },
            { email: true },
          ]}>
          <Field autoComplete="email" />
        </Form.Item>

        <Form.Item
          type="text"
          sm
          label={LangConverter('Company Name', lang.value)}
          name="companyName"
          placeholder={LangConverter('Company Name', lang.value)}>
          <Field />
        </Form.Item>
        <Form.Item
          sm
          type="select"
          options={RESELLER_TYPES}
          label={t('Reseller Type')}
          name="typeOfAuthorizedCenter"
          placeholder={t('Select Reseller Type')}
          rules={[{ required: true, message: t('Please select a type') }]}>
          <Select />
        </Form.Item>
        <Form.Item
          type="text"
          sm
          label={LangConverter('Codice Fiscale', lang.value)}
          name="codiceFiscale"
          placeholder={LangConverter('Codice Fiscale', lang.value)}
          rules={[
            { required: true, message: LangConverter('Please enter tax code', lang.value) },
            {
              pattern: /^(?=.*[A-Z])(?=.*\d)[A-Z0-9]{16}$/,
              message: LangConverter('Tax code must be 16 characters', lang.value),
            },
            { changeRegex: 'codice_fiscale' },
          ]}>
          <Field />
        </Form.Item>
        <Form.Item
          type="number"
          sm
          label={LangConverter('Partita Iva', lang.value)}
          name="partitaIva"
          placeholder={LangConverter('123456789', lang.value)}
          rules={[
            {
              pattern: /^\d+(\.\d{1,2})?$/,
              message: LangConverter('Enter a valid number with up to 2 decimal places', lang.value),
            },
          ]}>
          <Field step="0.01" />
        </Form.Item>
        <Form.Item
          type="email"
          sm
          label={LangConverter('Notification Email', lang.value)}
          name="notificationEmail"
          placeholder={LangConverter('E-mail', lang.value)}
          rules={[
            {
              required: true,
              message: LangConverter('Notification email is required.', lang.value),
            },
            { email: true },
          ]}>
          <Field />
        </Form.Item>
        <Form.Item
          type="text"
          sm
          label={LangConverter('Phone Number', lang.value)}
          name="phoneNumber"
          placeholder="(XXX) XXX-XXXX"
          rules={[
            {
              required: true,
              message: LangConverter('Phone Number is required', lang.value),
            },
            { changeRegex: 'phone_number' },
          ]}>
          <Field />
        </Form.Item>
        <Form.Item
          type="text"
          sm
          label={LangConverter('Mobile Number', lang.value)}
          name="mobileNumber"
          placeholder="(XXX) XXX-XXXX"
          rules={[{ changeRegex: 'phone_number' }]}>
          <Field />
        </Form.Item>
        <Form.Item
          type="text"
          sm
          label={LangConverter('Address', lang.value)}
          name="address"
          placeholder={LangConverter('Address', lang.value)}
          rules={[
            {
              required: true,
              message: LangConverter('Address is required', lang.value),
            },
          ]}>
          <Field />
        </Form.Item>
        <Form.Item
          type="text"
          sm
          label={LangConverter('City', lang.value)}
          name="city"
          placeholder={LangConverter('City', lang.value)}
          rules={[
            {
              required: true,
              message: LangConverter('City is required', lang.value),
            },
          ]}>
          <Field />
        </Form.Item>
        <Form.Item
          type="text"
          sm
          label={LangConverter('Area Code', lang.value)}
          name="areaCode"
          placeholder={LangConverter('Area', lang.value)}
          rules={[
            {
              required: true,
              message: LangConverter('Area Code is required', lang.value),
            },
          ]}>
          <Field />
        </Form.Item>
        <Form.Item
          type="text"
          sm
          label={LangConverter('Zip Code', lang.value)}
          name="zipCode"
          placeholder={LangConverter('Zip Code', lang.value)}
          rules={[
            {
              required: true,
              message: LangConverter('Zip Code is required', lang.value),
            },
          ]}>
          <Field />
        </Form.Item>
        <Form.Item
          type="text"
          sm
          label={LangConverter('Telegram Id', lang.value)}
          name="telegramId"
          placeholder="Telegram Id">
          <Field />
        </Form.Item>
      </Grid>
      <Button
        disabled={loading}
        loading={loading}
        type="primary"
        htmlType="submit"
        css={`
          margin-top: 20px;
        `}>
        {reseller ? LangConverter('Update', lang.value) : LangConverter('Create', lang.value)}
      </Button>
    </Form>
  );
}

export default ResellerForm;
